import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SearchOutlined } from "@ant-design/icons";
import { Empty, FreeTable } from "@core/rc-components";
import { useRequest } from "ahooks";
import { Card, Col, Input, Pagination, Row, Spin, Tree } from "antd";
import { useEffect, useRef, useState } from "react";
import './index.less';
const defaultHeight = 'calc(100vh - 48px - 120px)';
export const FreeTreeTable = ({ tree, tableProps, rowProps, tableLayoutCardProps, renderLeft, renderRight, heightSet }) => {
    const { treeApi, pagination: treePagination, searchProps: treeSearchProps, width = '288px', treeProps, searchTableKey = 'keyWord', searchKey = 'name' } = tree || {};
    const [treeData, setTreeData] = useState([]);
    const [treeActiveKey, setTreeActiveKey] = useState('');
    const searchRef = useRef(null);
    const [treePage, setTreePage] = useState({
        pageNum: 1,
        pageSize: 20,
        total: 0
    });
    const actionRef = useRef();
    const { loading: treeLoading, run: runTree } = useRequest((prams) => treeApi ? treeApi(prams) : Promise.resolve({ rows: [] }), {
        manual: true,
        onSuccess: (res, params) => {
            let resData = res || [];
            if (treePagination !== false) {
                resData = res?.rows || [];
                setTreePage({
                    ...treePage,
                    pageNum: params?.pageNum || 1,
                    total: res.total ?? 0
                });
            }
            if (!treeActiveKey) {
                setTreeActiveKey(resData?.[0]?.[treeProps?.fieldNames?.key || 'key']);
            }
            setTreeData(resData);
        }
    });
    const queryTreeHandler = () => {
        if (typeof renderLeft === 'function') {
            return;
        }
        runTree({
            [searchKey]: searchRef.current?.input?.value,
            ...(treePagination === false ? {} : {
                pageNum: treePage.pageNum,
                pageSize: treePage.pageSize
            })
        });
    };
    const onTreeActiveChange = (treeKey, e) => {
        // console.log('onTreeActiveChange', treeKey)
        if (treeKey?.[0]) {
            setTreeActiveKey(treeKey?.[0]);
        }
        treeProps?.onSelect?.(treeKey, e);
    };
    const tableHtml = tableProps === false ? '' : _jsx(FreeTable, { actionRef: actionRef, ...tableProps, cardProps: {
            ...tableProps.cardProps ?? {},
            bodyStyle: {
                padding: 0,
                // @ts-ignore
                ...(tableProps.cardProps?.bodyStyle ?? {})
            }
        }, options: tableProps?.options === false ? false : {
            ...(tableProps?.options ?? {}),
            search: {
                name: searchTableKey,
                placeholder: '请输入',
                density: false,
                fullScreen: false,
                reload: false,
                // @ts-ignore
                ...(tableProps?.options?.search ?? {}),
            }
        }, manualRequest: true, request: (params) => {
            if (!treeActiveKey) {
                return {
                    data: [],
                    total: 0
                };
            }
            return tableProps.request ? tableProps.request({
                ...params,
                [searchTableKey]: treeActiveKey
            }) : Promise.resolve({
                data: []
            });
        } });
    useEffect(() => {
        queryTreeHandler();
    }, [treePage.pageNum]);
    useEffect(() => {
        if (tableProps !== false) {
            if (tableProps.actionRef) {
                // @ts-ignore
                tableProps.actionRef?.current?.reloadAndRest?.();
            }
            else {
                actionRef.current?.reloadAndRest?.();
            }
        }
    }, [treeActiveKey]);
    return _jsxs(Row, { gutter: 16, wrap: false, ...rowProps, className: `free-tree-table-page ${rowProps?.className}`, children: [_jsx(Col, { flex: width, style: { overflow: 'hidden' }, children: _jsx("div", { className: "free-tree-side", children: renderLeft ? _jsx("div", { style: {
                            overflow: 'auto',
                            height: '100%',
                            padding: '0 8px'
                        }, children: _jsx("div", { style: { height: '0' }, children: renderLeft() }) }) : _jsxs(_Fragment, { children: [_jsx(Input.Search, { ref: searchRef, style: { width: '100%' }, prefix: _jsx(SearchOutlined, { style: { color: '#999999' } }), placeholder: "\u8BF7\u8F93\u5165", allowClear: true, ...treeSearchProps, onSearch: (val) => {
                                    if (treePage.pageNum === 1) {
                                        queryTreeHandler();
                                    }
                                    else {
                                        setTreePage({
                                            ...treePage,
                                            pageNum: 1
                                        });
                                    }
                                } }), _jsxs("div", { style: {
                                    paddingTop: '24px',
                                    overflow: 'auto',
                                    height: 'calc(100% - 24px)',
                                }, children: [_jsx("div", { style: { height: '0' }, children: _jsxs(Spin, { spinning: treeLoading, children: [_jsx(Tree, { blockNode: true, ...treeProps, selectedKeys: treeActiveKey ? [treeActiveKey] : undefined, onSelect: onTreeActiveChange, treeData: treeData }), treePagination === false ? '' :
                                                    _jsx("div", { className: "free-tree-pagination", children: _jsx(Pagination, { simple: true, ...treePagination, onChange: (page, pageSize) => setTreePage({
                                                                ...treePage,
                                                                pageNum: page,
                                                                pageSize,
                                                            }), defaultPageSize: treePage.pageSize }, "tree") })] }) }), !treeLoading && treeData?.length === 0 && (_jsx("div", { style: {
                                            height: 'calc(100% - 60px)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }, children: _jsx(Empty, {}) }))] })] }) }) }), _jsx(Col, { flex: "auto", children: _jsx(Card, { bordered: false, ...tableLayoutCardProps, bodyStyle: {
                        minHeight: heightSet?.minHeight ?? defaultHeight,
                        height: heightSet?.height == 'equalMin' ? defaultHeight : heightSet?.height ?? 'auto',
                        position: 'relative',
                        paddingBottom: 24,
                        overflow: 'auto',
                        ...(tableLayoutCardProps?.bodyStyle ?? {})
                    }, children: renderRight || tableProps === false ? renderRight?.(tableHtml) : tableHtml }) })] });
};
